export default "__VITE_ASSET__b6d077b3__"